module.exports = __webpack_public_path__ + "img/house_21.5bb7f40d.jpg";